import React from "react";
import "./ImageArrListItem.css";
import Draggable from "react-draggable";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import SelectableEditText from "../SelectableEditText/SelectableEditText";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";
import Col from "react-bootstrap/Col";
import { connect } from "react-redux";
import { ACDTYPE_VIDEO } from "../../model/ACDTypes";
import { setMediaUsedAction } from "../../redux/actions/pdfEditArticleAVList";
import {
  deleteImageArrAction,
  setSubLockingIDAction,
  snapShotEditArticleContentAction,
  updateArticleContentSubTextAction,
  saveArticleAction
} from "../../redux/actions/editArticlePanel";

class ImageArrListItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleStartDrag = this.handleStartDrag.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleStopDrag = this.handleStopDrag.bind(this);

    this.deleteClicked = this.deleteClicked.bind(this);
    this.lockClicked = this.lockClicked.bind(this);
    this.focus = this.focus.bind(this);
    this.onTextChange = this.onTextChange.bind(this);

    this.state = {
      style: { zIndex: 0 },
      position: { x: 0, y: 0 },
      isMoving: false
    };
  }

  focus() {
    const { itemID, imageItem, snapShotEditArticleContentAction } = this.props;

    if (itemID == null || imageItem == null) {
      return;
    }

    snapShotEditArticleContentAction({ id: itemID, subID: imageItem.id });
  }

  onTextChange(event) {
    const {
      itemID,
      imageItem,
      updateArticleContentSubTextAction,
      saveArticleAction,
      articleID
    } = this.props;

    if (itemID == null || imageItem == null) {
      return;
    }

    updateArticleContentSubTextAction({
      id: itemID,
      subID: imageItem.id,
      text: event.target.value
    });
    saveArticleAction(articleID);
  }

  lockClicked() {
    const {
      itemID,
      imageItem,
      setSubLockingIDAction,
      lockingID,
      subLockingID
    } = this.props;

    if (itemID == null || imageItem == null) {
      return;
    }

    if (lockingID === itemID && subLockingID === imageItem.id) {
      setSubLockingIDAction({ lockingID: null, subLockingID: null });
    } else {
      setSubLockingIDAction({ lockingID: itemID, subLockingID: imageItem.id });
    }
  }

  deleteClicked() {
    const {
      itemID,
      imageItem,
      deleteImageArrAction,
      saveArticleAction,
      articleID,
      setMediaUsedAction
    } = this.props;

    if (itemID == null || imageItem == null) {
      return;
    }

    if (imageItem.dataType === ACDTYPE_VIDEO) {
      setMediaUsedAction({ mediaID: imageItem.media.id, articleID: null });
    }

    deleteImageArrAction({ id: itemID, deleteImageID: imageItem.id });
    saveArticleAction(articleID);
  }

  handleStartDrag(e) {
    e.preventDefault();

    const { updateScrollTop } = this.props;

    updateScrollTop();

    this.setState({
      style: { zIndex: 100 },
      isMoving: true
    });
  }

  handleDrag(e) {
    const { getPanelPosition, setCurDragY, getCardTop } = this.props;

    const newY = getRelXY(e, getPanelPosition()).y - getCardTop();

    if (this.lastFireY == null || Math.abs(newY - this.lastFireY) > 10) {
      setCurDragY(newY);

      this.lastFireY = newY;
      this.setState({});
    }
  }

  handleStopDrag(e) {
    const { insertItem, setCurDragY, imageItem } = this.props;

    insertItem(imageItem.id);

    setCurDragY(-1);

    this.setState({
      style: { zIndex: 0 },
      position: { x: 0, y: 0 },
      isMoving: false
    });
  }

  render() {
    const {
      imageItem,
      isHighlight,
      lockingID,
      subLockingID,
      itemID
    } = this.props;
    const { position, style, isMoving } = this.state;

    let imageUri;

    if (imageItem.dataType === ACDTYPE_VIDEO) {
      imageUri = `${process.env.REACT_APP_API_ROOT}artworks/${
        imageItem.media.thumbnail.id
      }/static/thumbnail`;
    } else {
      imageUri = `${process.env.REACT_APP_API_ROOT}artworks/${
        imageItem.image.id
      }/static/thumbnail`;
    }

    const expandHeight = isHighlight && !isMoving ? 55 : 5;

    const isLocking = lockingID === itemID && subLockingID === imageItem.id;
    const bgStyle = isLocking ? { backgroundColor: "#ffc107" } : {};

    return (
      <Draggable
        handle=".gallery_handle"
        cancel=".cancel_in_move"
        position={position}
        positionOffset={{ x: 0, y: 0 }}
        onStart={this.handleStartDrag}
        onDrag={this.handleDrag}
        onStop={this.handleStopDrag}
      >
        <Container
          ref={this.props.forwardRef}
          className="gallery_card_container"
          style={style}
        >
          <Row
            className="gallery_expand"
            style={{ height: expandHeight + "px" }}
          />
          <Row className="gallery_card_main_part" style={bgStyle}>
            <Col
              xs="3"
              sm="3"
              md="2"
              xl="2"
              lg="2"
              style={{ padding: "5px" }}
              className="gallery_handle"
            >
              <Image src={imageUri} className="gallery_image" />
            </Col>
            <Col xs="8" sm="8" md="9" xl="9" lg="9" style={{ padding: "5px" }}>
              <SelectableEditText
                onFocus={this.focus}
                //onBlur={this.blur}
                value={imageItem.text}
                style={{ height: "90px", overflow: "scroll" }}
                onChange={this.onTextChange}
                className="gallery_text cancel_in_move"
              />
            </Col>
            <Col xs="1" sm="1" md="1" xl="1" lg="1" style={{ padding: "5px" }}>
              <Button
                variant={isLocking ? "primary" : "secondary"}
                size="sm"
                className="gallery_delete_btn cancel_in_move"
                onClick={this.lockClicked}
              >
                <span className="fa fa-lock" />
              </Button>
              <Button
                variant="danger"
                size="sm"
                className="gallery_delete_btn cancel_in_move cancel_move"
                onClick={this.deleteClicked}
              >
                <span className="fa fa-trash" />
              </Button>
            </Col>
          </Row>
        </Container>
      </Draggable>
    );
  }
}

function getRelXY(e, panelPosition) {
  const mousePosition = getClientPos(e);

  return {
    x: mousePosition.x - panelPosition.x,
    y: mousePosition.y - panelPosition.y + panelPosition.scrollTop
  };
}

function getClientPos(e) {
  let clientX;
  let clientY;

  if (e.touches) {
    [{ clientX, clientY }] = e.touches;
  } else {
    ({ clientX, clientY } = e);
  }

  return {
    x: clientX,
    y: clientY
  };
}

const mapState = (state, ownProps) => {
  const { editArticlePanel } = state;

  return {
    lockingID: editArticlePanel.lockingID,
    subLockingID: editArticlePanel.subLockingID
  };
};

const mapDispatch = {
  deleteImageArrAction,
  setSubLockingIDAction,
  snapShotEditArticleContentAction,
  updateArticleContentSubTextAction,
  saveArticleAction,
  setMediaUsedAction
};

export default connect(
  mapState,
  mapDispatch
)(ImageArrListItem);
